import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { NavLink } from "react-router-dom";
import './style.css';

const menus = [
    {
        id: 1,
        title: 'Home',
        link: '/home',
       
    },
    {
        id: 88,
        title: 'About Us',
        link: '/about2',
    },
    {
        id: 7,
        title: 'Our Services',
        link: '/',
        submenu: [
            {
                id: 71,
                title: 'Home Interiors',
                link: '/homeinteriors',
            },
            {
                id: 71,
                title: 'Commercial Interiors',
                link: '/commercialinteriors',
            },
            {
                id: 72,
                title: 'Office Interiors',
                link: '/officeinteriors'
            },
             {
                id: 73,
                title: 'Electrical & Lighting Solutions',
                link: '/electricallighting'
            },

             {
                id: 73,
                title: 'Painting Works',
                link: '/paintingwork'
            },

             {
                id: 73,
                title: 'Plumbing Works',
                link: '/plumbingwork'
            },

             {
                id: 73,
                title: 'Renovation Works',
                link: '/renovationwork'
            },

            {
                id: 73,
                title: 'Carpentry Works',
                link: '/Carpentryworks'
            },
        ]
    },
    {
        id:100,
        title: 'Gallery',
        link: '/gallery',
    },
   
    {
        id: 88,
        title: 'Contact',
        link: '/contact',
    }
    



]


const MobileMenu = () => {

    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item, mn) => {
                        return (
                            <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                                {item.submenu ?
                                    <Fragment>
                                        <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>{item.title}
                                            <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                        </p>
                                        <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                            <List className="subMenu">
                                                <Fragment>
                                                    {item.submenu.map((submenu, i) => {
                                                        return (
                                                            <ListItem key={i}>
                                                                <NavLink onClick={ClickHandler} className="active"
                                                                    to={submenu.link}>{submenu.title}</NavLink>
                                                            </ListItem>
                                                        )
                                                    })}
                                                </Fragment>
                                            </List>
                                        </Collapse>
                                    </Fragment>
                                    : <NavLink className="active"
                                        to={item.link}>{item.title}</NavLink>
                                }
                            </ListItem>
                        )
                    })}
                </ul>

            </div>

            <div className="showmenu mobail-menu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenu;